import React from 'react';
import './StandardsSection.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import standardsFrame from '../../Assets/images/standards_frame.png';
import cvorLogo from '../../Assets/images/cvor.png';
import wsibLogo from '../../Assets/images/wsib.png';
import insuranceLogo from '../../Assets/images/insurance_permits.png';

const certifications = [
  {
    id: 'cvor',
    logo: cvorLogo,
    logoAlt: 'CVOR – Commercial Vehicle Operator Registration',
    label: 'MTO Safety & CVOR Certified',
  },
  {
    id: 'wsib',
    logo: wsibLogo,
    logoAlt: 'WSIB Ontario',
    label: 'WSIB Clearance Certificates',
  },
  {
    id: 'insurance',
    logo: insuranceLogo,
    logoAlt: 'Valid Insurance & Permits shield icon',
    label: 'Valid Insurance & Permits',
  },
];

const StandardsSection = () => {
  const titleRef = useAnimateOnScroll();
  const certsRef = useAnimateOnScroll();

  return (
  <section className="standards-section">
    <div className="standards-title-area">
      <h2 ref={titleRef} className="standards-title slide-down">
        Built for{' '}
        <span className="standards-title__highlight">Ontario</span>{' '}
        Standards
      </h2>
    </div>

    <div className="standards-divider" aria-hidden="true" />

    <div
      className="standards-certs-area"
      style={{ backgroundImage: `url(${standardsFrame})` }}
    >
      <div className="container">
        <div ref={certsRef} className="standards-certs slide-up">
          {certifications.map((cert) => (
            <div key={cert.id} className="standards-cert-item">
              <img
                src={cert.logo}
                alt={cert.logoAlt}
                className="standards-cert-item__logo"
              />
              <p className="standards-cert-item__label">{cert.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};

export default StandardsSection;
